import { DemoDock } from './components/DemoDock.tsx';
import { useEffect } from 'react';
import { Sprite } from './components/Sprite.tsx';
import { TopBar } from './components/TopBar.tsx';
import { Hero } from './components/Hero.tsx';
import { LandingIntro } from './components/LandingIntro.tsx';
import { BuyerExperience } from './components/BuyerExperience.tsx';
import { UseCases } from './components/UseCases.tsx';
import { Pilot } from './components/Pilot.tsx';
import { TryOut } from './components/TryOut.tsx';
import { Strip } from './components/Strip.tsx';

import { HowItWorks } from './components/HowItWorks.tsx';
import { Story } from './components/Story.tsx';
import { useRevealOnScroll, useScrambleEverywhere } from './motion.ts';
import { Gate } from './components/Gate.tsx';


import { Safe } from './components/Safe.tsx';
import { Close } from './components/Close.tsx';
import { DemoProvider } from './components/Demo.tsx';
import { LegalPage } from './components/LegalPage.tsx';

/** Product overview, real interface examples, boundaries, questions, and demo. */
export default function App() {
  const pathname = location.pathname.replace(/\/+$/, '') || '/';

  // The static build was HTML, so the browser resolved `#gate` itself. Rendering
  // client-side means the target does not exist when the hash is read, and a
  // link somebody shared lands at the top of the page instead. In-page clicks
  // were never affected, which is exactly why this is easy to miss.
  useEffect(() => {
    const id = location.hash.slice(1);
    if (!id) return;
    document.getElementById(id)?.scrollIntoView();
  }, []);

  useRevealOnScroll();
  useScrambleEverywhere();

  if (pathname === '/privacy') return <LegalPage document="privacy" />;
  if (pathname === '/terms') return <LegalPage document="terms" />;

  return (
    <DemoProvider>
      <Sprite />
      <a className="skip-link" href="#main">Skip to content</a>
      <TopBar />
      <main id="main">
      <LandingIntro />
      <Story />
      <BuyerExperience />
      <Strip />
      <UseCases />

      <HowItWorks />
      <Hero />
      <Gate />


      <TryOut />
      <Safe />
      <Pilot />
      </main>
      <Close />
      <DemoDock />
    </DemoProvider>
  );
}

